// extracted by mini-css-extract-plugin
export var configurationSection = "_se-0";